import styled from 'styled-components';

import { Hero as XingternalHero } from '@xingternal/typography';

import {
  scale100,
  scale140,
  scale240,
  scale250,
  scale260,
  scale300,
  scale320,
} from '@xingternal/tokens';

import { mediaConfined } from '@xingternal/layout-tokens';
import { sectionInnerContainerMixin, sectionMixin } from '../variables.style';

import handIllustration from './images/hand.svg';

export const Container = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: ${scale240};
  background-image: url(${handIllustration});
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: ${scale250} auto;
  ${sectionMixin};
  ${sectionInnerContainerMixin};

  @media ${mediaConfined} {
    padding-bottom: ${scale300};
    background-size: ${scale320} auto;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Badge = styled.a`
  width: ${scale260};

  @media ${mediaConfined} {
    width: ${scale320};
  }

  & > img {
    width: 100%;
  }

  &:first-child {
    margin-right: ${scale100};

    @media ${mediaConfined} {
      margin-right: ${scale140};
    }
  }
`;

export const Hero = styled(XingternalHero)`
  margin-bottom: ${scale140};
`;
